import {
  HeaderRow,
  LeaderboardContainer,
  LeaderboardHeader,
  LeaderboardTable,
  LeftLeaderboardHeader,
  TightLeaderboardHeader,
  TotalLeaderboardHeader,
} from "./styles";
import { selectTournamentPickemDetails } from "selectors/PickemDetails";
import { TournamentLeaderboardUser } from "model/Leaderboard/User/TournamentLeaderboardUser";
import { TournamentPickemLeaderboardRow } from "./TournamentPickemLeaderboardRow";
import { useAppSelector } from "app/hooks";

interface Props {
  tournamentId: string;
  leaderboardUsers: TournamentLeaderboardUser[];
  paginationVisible: boolean;
  loggedInLeaderboardUser?: TournamentLeaderboardUser;
}

export const TournamentPickemLeaderboard = ({
  tournamentId,
  leaderboardUsers,
  loggedInLeaderboardUser,
  paginationVisible,
}: Props) => {
  const sortedUsers = getSortedUids(leaderboardUsers);
  const tournamentPickemDetails =
    useAppSelector((state) =>
      selectTournamentPickemDetails(state, tournamentId)
    )?.pickems ?? [];
  const segmentIds =
    tournamentId === "Bdlx1"
      ? ["Div1", "Div2", "Playoffs", "Promo"]
      : ["Div1", "Div2"];
  const showTotalColumn = tournamentPickemDetails.length > 1;

  return (
    <LeaderboardContainer>
      <LeaderboardTable>
        <HeaderRow>
          <TightLeaderboardHeader>Pos.</TightLeaderboardHeader>
          <LeftLeaderboardHeader>Username</LeftLeaderboardHeader>
          {tournamentPickemDetails.length > 1 && (
            <TotalLeaderboardHeader>Total</TotalLeaderboardHeader>
          )}
          {(tournamentId === "Bdlx1"
            ? ["Div 1", "Div 2", "PO", "Pr"]
            : ["Div 1", "Div 2"]
          ).map((x) => (
            <LeaderboardHeader key={x}>{x}</LeaderboardHeader>
          ))}
        </HeaderRow>
        {!!loggedInLeaderboardUser && (
          <TournamentPickemLeaderboardRow
            leaderboardUser={loggedInLeaderboardUser}
            segmentIds={segmentIds}
            highlight={true}
            seperate={true}
            showTotalColumn={showTotalColumn}
          />
        )}
        {sortedUsers.map((lbUser) => {
          return (
            <TournamentPickemLeaderboardRow
              leaderboardUser={lbUser}
              segmentIds={segmentIds}
              highlight={lbUser === loggedInLeaderboardUser}
              hideBottomBorder={
                !paginationVisible && sortedUsers.slice(-1)[0] === lbUser
              }
              showTotalColumn={showTotalColumn}
            />
          );
        })}
      </LeaderboardTable>
    </LeaderboardContainer>
  );
};

const getSortedUids = (leaderboardUsers: TournamentLeaderboardUser[]) => {
  return leaderboardUsers.sort((a, b) => a.sort - b.sort);
};
